import moment from 'moment'
import { isValidPhoneNumber } from 'react-phone-number-input'

//
// regex found from https://awik.io/international-email-address-validation-javascript/
//

const REGEX_EMAIL = /^(?!\.)((?!.*\.{2})[a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFFu20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\.!#$%&'*+-/=?^_`{|}~\-\d]+)@(?!\.)([a-zA-Z0-9\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF\-\.\d]+)((\.([a-zA-Z\u0080-\u00FF\u0100-\u017F\u0180-\u024F\u0250-\u02AF\u0300-\u036F\u0370-\u03FF\u0400-\u04FF\u0500-\u052F\u0530-\u058F\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u07C0-\u07FF\u0900-\u097F\u0980-\u09FF\u0A00-\u0A7F\u0A80-\u0AFF\u0B00-\u0B7F\u0B80-\u0BFF\u0C00-\u0C7F\u0C80-\u0CFF\u0D00-\u0D7F\u0D80-\u0DFF\u0E00-\u0E7F\u0E80-\u0EFF\u0F00-\u0FFF\u1000-\u109F\u10A0-\u10FF\u1100-\u11FF\u1200-\u137F\u1380-\u139F\u13A0-\u13FF\u1400-\u167F\u1680-\u169F\u16A0-\u16FF\u1700-\u171F\u1720-\u173F\u1740-\u175F\u1760-\u177F\u1780-\u17FF\u1800-\u18AF\u1900-\u194F\u1950-\u197F\u1980-\u19DF\u19E0-\u19FF\u1A00-\u1A1F\u1B00-\u1B7F\u1D00-\u1D7F\u1D80-\u1DBF\u1DC0-\u1DFF\u1E00-\u1EFF\u1F00-\u1FFF\u20D0-\u20FF\u2100-\u214F\u2C00-\u2C5F\u2C60-\u2C7F\u2C80-\u2CFF\u2D00-\u2D2F\u2D30-\u2D7F\u2D80-\u2DDF\u2F00-\u2FDF\u2FF0-\u2FFF\u3040-\u309F\u30A0-\u30FF\u3100-\u312F\u3130-\u318F\u3190-\u319F\u31C0-\u31EF\u31F0-\u31FF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FFF\uA000-\uA48F\uA490-\uA4CF\uA700-\uA71F\uA800-\uA82F\uA840-\uA87F\uAC00-\uD7AF\uF900-\uFAFF]){2,63})+)$/i

const REGEX_DATE = /^([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/

const NAME_TYPE_MAP = {
  fname: 'First name',
  lname: 'Last name',
}

function getNameError(name, type, strings) {
  if (name.length === 0) {
    if (type === NAME_TYPE_MAP.fname) return strings.name_first_error_empty_self
    if (type === NAME_TYPE_MAP.lname) return strings.name_last_error_empty_self
  }
  return null
}

export function getEmailError(email, strings) {
  if (email.length === 0) {
    return strings.email_error_empty_self
  }

  if (REGEX_EMAIL.test(email)) {
    return null
  }
  return strings.email_error_invalid_self
}

function getPhoneError(phone, strings, countryDialCode) {
  if (!phone) {
    return strings.phone_error_empty_self
  }
  const phoneWithDialCode = phone.includes(countryDialCode)
    ? phone
    : `${countryDialCode}${phone}`
  if (!!phone && isValidPhoneNumber(phoneWithDialCode)) {
    return null
  }
  return strings.phone_error_invalid_self
}

/**
 * Checks that dob object is not empty, and is not a future date
 * @param {Moment} dob
 */
function getDobError(dob, strings) {
  // if (!dob || typeof dob === 'undefined') {
  //   return strings.dob_error_empty_self
  // }

  if (dob && !REGEX_DATE.test(dob)) return strings.dob_error_invalid_self

  if (moment().isBefore(moment(dob))) {
    return strings.dob_error_future_self
  }
  return null
}

function getSiteCodeError(siteCode, strings) {
  if (siteCode.length === 0) return strings.site_code_error_empty_self
  return null
}

function getRecaptchaError(captchaToken, strings) {
  if (!captchaToken) {
    return strings.recaptcha_error_self
  }
  return null
}

function getPhoneConsentError(hasSmsConsent, strings) {
  if (hasSmsConsent === null || hasSmsConsent === undefined) {
    return strings.phone_error_empty_self
  }
  return null
}

const fieldValidation = {
  firstname: getNameError,
  lastname: getNameError,
  email: getEmailError,
  date_of_birth: getDobError,
  code: getSiteCodeError,
  phone: getPhoneError,
  recaptcha: getRecaptchaError,
}

export function getParticipantErrors(
  {
    fname,
    lname,
    email,
    date_of_birth,
    siteCode,
    phone,
    hasSmsConsent,
    countryDialCode,
  },
  captchaToken,
  strings,
  disabledFields,
) {
  const errors = {}
  const mandatoryValidations = Object.keys(fieldValidation)
    .filter(field => !disabledFields?.includes(field))
    .reduce((res, key) => ((res[key] = fieldValidation[key]), res), {})

  for (const [field, fn] of Object.entries(mandatoryValidations)) {
    switch (field) {
      case 'firstname':
        errors.fname = fn(fname, 'First name', strings)
        break
      case 'lastname':
        errors.lname = fn(lname, 'Last name', strings)
        break
      case 'email':
        errors[field] = fn(email, strings)
        break
      case 'date_of_birth':
        errors[field] = fn(date_of_birth, strings)
        break
      case 'code':
        errors.siteCode = fn(siteCode, strings)
        break
      case 'phone': {
        const consentError = getPhoneConsentError(hasSmsConsent, strings)
        if (consentError) {
          errors[field] = consentError
        } else if (hasSmsConsent) {
          // Only require a phone number when the user opts into SMS
          errors[field] = fn(phone, strings, countryDialCode)
        }
        break
      }
      case 'recaptcha':
        errors[field] = fn(captchaToken, strings)
        break
      default:
        break
    }
  }
  // Return the errors object without null values
  return Object.keys(errors)
    .filter(key => errors[key])
    .reduce((prevObj, key) => ({ ...prevObj, [key]: errors[key] }), {})
}



// WEBPACK FOOTER //
// ./src/utils/participantValidation.js